import {useProductDetailCountdownFlashsaleLazyQuery} from '@/framework/gql/product-detail-countdown-flashsale.graphql';

export function useProductDetailCountdownFlashsale() {
    const [getProductDetailCountdownFlashsaleQuery, {data, loading, error}] =
        useProductDetailCountdownFlashsaleLazyQuery();
    const getProductDetailCountdownFlashsale = (productId: number) => {
        getProductDetailCountdownFlashsaleQuery({
            variables: {
                productId,
            },
        });
    };
    return {
        getProductDetailCountdownFlashsale,
        data: data?.flashSaleProduct?.sales_data,
        loading,
        error,
    };
}
